__webpack_require__.p = "https://assets.globe.newsroomq.com:443/packs/";